<template>
    <div class="mytest">
        <div>
            <el-radio-group v-model="examStatus" size="small" @change="handleChange">
                <el-radio-button v-for="item in arrExamApproved" :key="item.id" :label="item.id">{{item.name}}
                </el-radio-button>
            </el-radio-group>
        </div>
        <br>
        <is-empty :show="examList.length > 0" message="暂时没有数据~">
            <el-table class="test-card" style="width: 100%" :data="examList" :show-header="false">
                <el-table-column label="标签" width="80">
                    <template slot-scope="scope">
                        <el-tag size="mini" effect="dark" :type="scope.row.tagType">
                            {{scope.row.tagText}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="详情">
                    <template slot-scope="scope">
                        <h4 v-text="scope.row.examName"></h4>
                        <ul class="test-time">
                            <li>
                                考试时长：<span v-text="scope.row.time"></span>分钟
                            </li>
                            <!-- <li>
                                总分：<span>XX</span>分
                            </li> -->
                            <!-- <li v-if="scope.row.status == 2">
                                交卷时间：<span>XX</span>
                            </li> -->
                            <li>
                                起止时间：<span v-text="scope.row.startTime"></span> ~ <span
                                    v-text="scope.row.endTime"></span>
                            </li>
                        </ul>
                    </template>
                </el-table-column>
                <el-table-column label="得分"></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain v-if="scope.row.status === 1"
                            @click="startTest(scope.row.examId)"
                            :disabled="examTime(scope.row.startTime,scope.row.endTime)">开始考试</el-button>
                        <el-button size="mini" type="primary" plain v-else @click="seeTest(scope.row.id)">查看考试
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </is-empty>
        <br>
        <el-pagination background prev-text="上一页" next-text="下一页" layout="total, sizes, prev, pager, next, jumper"
            :total="page.total" :current-page="page.page" :page-size="page.limit" :pager-count="page.pagerCount"
            @size-change="handleLimitChange" @current-change="handlePageChange">
        </el-pagination>
    </div>
</template>

<script>
import isEmpty from '@/components/common/is-empty'
import { getStudentsExam } from '@/api/exam/etuserexamhistory'
import { open_blank } from '@/utils/router'
export default {
    data () {
        return {
            page: {
                page: 1, // 当前页
                limit: 10, // 每页条目数
                total: 0,
                pagerCount: 7, // 页码按钮的数量，当总页数超过该值时会折叠(大于等于 5 且小于等于 21 的奇数)
            },
            examList: [],
            examStatus: 1, // 当前考试状态
            arrExamApproved: [
                { id: 'all', name: '全部', tagType: '', tagText: '' },
                // { id: 0, name: '未通过审核', tagType: 'info', tagText: '未通过' },
                { id: 1, name: '未考试', tagType: 'success', tagText: '未考试' },
                { id: 2, name: '已交卷', tagType: 'warning', tagText: '已交卷' },
                { id: 3, name: '已阅卷', tagType: 'danger', tagText: '已阅卷' }
            ]
        };
    },
    components: {
        isEmpty
    },
    methods: {
        //计算考试时间
        examTime (s, e) {
            let st = new Date(s).getTime()
            let et = new Date(e).getTime()
            let now = new Date().getTime()
            if (st < now && now < et) {
                return false
            } else {
                return true
            }
        },
        init () {
            this.getStudentsExam()
        },
        // 开始考试
        startTest (examId) {
            open_blank({
                name: 'testInstructions',
                params: { id: examId }
            })
        },
        // 查看考试
        seeTest (recordId) {
            this.$router.push({
                name: 'testView',
                params: { recordId }
            });
        },
        // 分页查询学生考试列表
        getStudentsExam (params = {}) {
            let { limit, page } = this.page
            let oData = params
            if (this.examStatus != 'all') {
                oData.approved = this.examStatus
            }
            this.examList = []
            getStudentsExam(page, limit, oData).then(res => {
                let { list, totalCount } = res
                let arr = []
                this.$set(this.page, 'total', totalCount)
                list.map(item => {
                    let curApproved = this.arrExamApproved.filter(approved => {
                        return approved.id === item.status
                    })
                    let { tagType, tagText } = curApproved[0]
                    arr.push({
                        ...item,
                        tagType,
                        tagText
                    })
                })
                this.examList = arr
            })
        },
        handleChange () {
            this.$set(this.page, 'page', 1)
            this.getStudentsExam()
        },
        // limit 改变时会触发
        handleLimitChange (limit) {
            this.$set(this.page, 'limit', limit)
            this.getStudentsExam()
        },
        // page 改变时会触发
        handlePageChange (page) {
            this.$set(this.page, 'page', page)
            this.getStudentsExam()
        }
    },
    created () {
        this.init()
    }
};
</script>
